/**
 * 홈택스 「세금계산서등록양식(일반)_대량」 스타일 19열 헤더와 행 빌더.
 * 부가세 포함 금액 T 원 → 세액 floor(T/11), 공급가액 T−세액.
 */

export const TAX_INVOICE_BULK_HEADERS = [
  "전자세금계산서종류",
  "작성일자",
  "공급받는자등록번호",
  "공급받는자상호",
  "공급받는자성명",
  "사업장주소",
  "업태",
  "종목",
  "이메일",
  "공급가액합계",
  "세액합계",
  "비고",
  "일자1",
  "품목1",
  "수량1",
  "단가1",
  "공급가액1",
  "세액1",
  "영수/청구",
] as const;

export function formatTradeMonthLabelKo(yearMonth: string): string {
  const parts = yearMonth.split("-").map(Number);
  const year = parts[0];
  const month = parts[1];
  if (!year || !month) {
    return yearMonth;
  }
  return `${year}년 ${month}월 이용수수료`;
}

/** `<input type="date">` 값(YYYY-MM-DD) → 파일용 YYYYMMDD */
export function toYyyyMmDdCompact(isoDay: string): string {
  return isoDay.replaceAll("-", "");
}

export function defaultIssueDateAfterTradeMonth(yearMonth: string): string {
  const parts = yearMonth.split("-").map(Number);
  const year = parts[0] ?? new Date().getFullYear();
  const mm = parts[1] ?? 1;
  const idx = mm - 1;
  const firstNext = new Date(year, idx + 1, 1);
  const yy = firstNext.getFullYear();
  const mo = String(firstNext.getMonth() + 1).padStart(2, "0");
  const da = String(firstNext.getDate()).padStart(2, "0");
  return `${yy}-${mo}-${da}`;
}

export function splitVatInclusiveTotal(totalInclusive: number): {
  supply: number;
  vat: number;
} {
  const t = Math.round(totalInclusive);
  const vat = Math.floor(t / 11);
  const supply = t - vat;
  return { supply, vat };
}

export function digitsOnlyBusinessNumber(
  raw: string | null | undefined
): string {
  if (raw == null || raw === "") return "";
  return raw.replace(/\D/g, "");
}
